import useAffiliateConfig from "./useAffiliateConfig";
import useAppSelector from "./useAppSelector";
import { useMemo } from "react";
export default function useAgentSupportTextMessage() {
    var helpPhoneNumber = useAffiliateConfig().helpPhoneNumber;
    var userId = useAppSelector(function (state) { return state.configuration.userId; });
    var email = useAppSelector(function (state) {
        var _a, _b;
        if (state.unlinkedApplication.policyHolder.email) {
            return state.unlinkedApplication.policyHolder.email;
        }
        var autoPolicy = state.policies.auto[0];
        var homePolicy = state.policies.home[0];
        return (_a = autoPolicy === null || autoPolicy === void 0 ? void 0 : autoPolicy.policyHolder.email) !== null && _a !== void 0 ? _a : (_b = homePolicy === null || homePolicy === void 0 ? void 0 : homePolicy.policyHolder) === null || _b === void 0 ? void 0 : _b.email;
    });
    var helpString = email ? "My email is ".concat(email) : "My user ID is ".concat(userId);
    return useMemo(function () {
        return "sms://+".concat(helpPhoneNumber, ";?&body=").concat(encodeURIComponent("I would like some help switching car insurance. ".concat(helpString)));
    }, [helpPhoneNumber, helpString]);
}
